import { TypeExamStatus } from 'app/constants/types/exam.types'
import React from 'react'

type Props = {}

const TextStatus = {
  'standby-locked': 'Waiting for Exam',
  'standby-open': 'Waiting for Exam',
  'ongoing': 'On Going',
  'submitted': 'Submitted',
  'ended': 'Ended',
  'graded': 'Graded',
  'pending': 'Pending',
  'missing': 'Missing',
  // New status text
  'open': 'Available for Enrollment',
  'close': 'Enrollment Closed',
  'standby': 'Exam Ready',
  'countdown': 'Starting Soon',
}

export const getTextExamStatus = (status: TypeExamStatus): string => {

  return TextStatus[status]

}

const useExamStatus = (props: Props) => {
  return {

  }
}

export default useExamStatus
